import React from 'react'
import clsx from 'clsx'
import Button from '@material-ui/core/Button'
import { Skeleton } from '@material-ui/lab'
import { makeStyles } from '@material-ui/core/styles'

// Local replacement for react-storefront/option/TextProductOption.
const useStyles = makeStyles(
  theme => ({
    root: {
      '.rsf-po-selected &': {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
          borderColor: theme.palette.primary.main,
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        },
      },
    },
    strikeThrough: {
      height: '7px',
      borderWidth: '2px 0',
      borderStyle: 'solid',
      borderColor: '#f2f2f2',
      backgroundColor: '#666',
      position: 'relative',
      width: '100%',
      top: 'calc(-50% - 2px)',
      left: -2,
      borderRadius: 10,
    },
  }),
  { name: 'RSFTextProductOption' },
)

export default function TextProductOption({
  classes,
  className,
  selected = false,
  label,
  skeleton,
  buttonProps,
  onClick,
  disabled,
  strikeThroughDisabled = false,
  strikeThroughAngle = 27,
}) {
  classes = useStyles({ classes })

  if (skeleton) {
    return <Skeleton className={className} width={64} height={36} />
  }

  return (
    <>
      <Button
        {...buttonProps}
        disabled={disabled}
        className={clsx(className, classes.root)}
        variant={selected ? 'contained' : 'outlined'}
        color={selected ? 'primary' : 'default'}
        onClick={onClick}
      >
        {label}
      </Button>
      {disabled && strikeThroughDisabled && (
        <div
          className={classes.strikeThrough}
          style={{ transform: `rotate(${strikeThroughAngle}deg)` }}
        />
      )}
    </>
  )
}
